var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (this.fileCountDashboard)?_c('div',{staticClass:"chart-container"},[_c('bar',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOpt,"styles":_vm.myStyles}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }